type Props = {
  width?: string | number;
  height?: string | number;
  strokeColor?: string;
};

const SearchIconOutline = (props: Props) => {
  const { width = 16, height = 16, strokeColor = 'currentColor' } = props;
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ flexShrink: 0 }}
      aria-hidden="true"
      focusable="false"
    >
      <circle
        cx="6.5"
        cy="6.5"
        r="4.5"
        stroke={strokeColor}
        strokeWidth="1.5"
      />
      <line
        x1="10"
        y1="10"
        x2="14"
        y2="14"
        stroke={strokeColor}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  );
};

export default SearchIconOutline;
